import { render, staticRenderFns } from "./ProformaTable.vue?vue&type=template&id=03792936&scoped=true&lang=pug&"
import script from "./ProformaTable.vue?vue&type=script&lang=js&"
export * from "./ProformaTable.vue?vue&type=script&lang=js&"
import style0 from "./ProformaTable.vue?vue&type=style&index=0&id=03792936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03792936",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
